import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white shadow-sm sticky top-0 z-50 border-b border-gray-100" data-id="element-160">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-162">
          <a href="/" className="flex flex-col items-start group" data-id="element-163">
            <span className="text-2xl md:text-3xl font-extrabold text-benefika-teal tracking-tight group-hover:text-benefika-emerald transition-colors" data-id="element-164">
              Benefika
            </span>
            <span className="text-[10px] md:text-xs font-medium text-benefika-gray uppercase tracking-widest mt-[-2px]" data-id="element-165">
              by TicketMaestro
            </span>
          </a>
        </motion.div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8 items-center" data-id="element-166">
          <a href="/" className="text-benefika-charcoal hover:text-benefika-teal font-medium transition-colors" data-id="element-167">
            Inicio
          </a>
          <a href="/nosotros" className="text-benefika-charcoal hover:text-benefika-teal font-medium transition-colors" data-id="element-168">
            Nosotros
          </a>
          <a href="/#servicios" className="text-benefika-charcoal hover:text-benefika-teal font-medium transition-colors" data-id="element-169">
            Servicios
          </a>
          <a href="/#caracteristicas" className="text-benefika-charcoal hover:text-benefika-teal font-medium transition-colors" data-id="element-170">
            ¿Por qué elegirnos?
          </a>
          <a href="/programas-clientes" className="text-benefika-charcoal hover:text-benefika-teal font-medium transition-colors" data-id="element-171">
            Programas y Clientes
          </a>
          <a href="mailto:contacto@benefika.net" className="bg-benefika-teal hover:bg-benefika-emerald text-white px-5 py-2 rounded-full font-medium transition-all shadow-sm hover:shadow-md" data-id="element-172">
            Contactar
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-benefika-charcoal p-2" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-173">
          {isMenuOpen ? <XIcon size={24} data-id="element-174" /> : <MenuIcon size={24} data-id="element-175" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} exit={{
      opacity: 0,
      height: 0
    }} className="md:hidden bg-white border-t border-gray-100 shadow-lg" data-id="element-176">
          <nav className="flex flex-col px-4 py-6 space-y-4" data-id="element-177">
            <a href="/" className="text-benefika-charcoal hover:text-benefika-teal font-medium text-lg transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-178">
              Inicio
            </a>
            <a href="/nosotros" className="text-benefika-charcoal hover:text-benefika-teal font-medium text-lg transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-179">
              Nosotros
            </a>
            <a href="/#servicios" className="text-benefika-charcoal hover:text-benefika-teal font-medium text-lg transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-180">
              Servicios
            </a>
            <a href="/#caracteristicas" className="text-benefika-charcoal hover:text-benefika-teal font-medium text-lg transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-181">
              ¿Por qué elegirnos?
            </a>
            <a href="/programas-clientes" className="text-benefika-charcoal hover:text-benefika-teal font-medium text-lg transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-182">
              Programas y Clientes
            </a>
            <a href="mailto:contacto@benefika.net" className="bg-benefika-teal text-white text-center px-4 py-3 rounded-md font-medium mt-4" onClick={() => setIsMenuOpen(false)} data-id="element-183">
              Contactar
            </a>
          </nav>
        </motion.div>}
    </header>;
};
export default Header;